import { MedplumClient } from "@medplum/core";
import { Coverage } from "@medplum/fhirtypes";

import { QuiltedHealthCodes } from "@/fhir/enums/quilted-health";
import { joinReferenceString } from "@/utils/medplum";

export async function getInsuranceInformation(
  medplum: MedplumClient,
  clientId: string,
): Promise<{
  coverage: Coverage | undefined;
  medicaidResponseCode: string;
  paymentMethod: string;
}> {
  const coverage = await medplum
    .searchResources("Coverage", {
      beneficiary: joinReferenceString("Patient", clientId),
      status: "active",
    })
    .then((result) => {
      return result.bundle?.entry
        ?.map((entry) => (entry.resource?.order === 1 ? entry.resource : undefined))
        .filter(Boolean) as Coverage[] | undefined;
    });

  const medicaidResponseCode = await medplum
    .searchOne("Observation", {
      subject: joinReferenceString("Patient", clientId),
      code: QuiltedHealthCodes.MedicaidEligibility,
      _sort: "-_lastUpdated",
    })
    .then((result) => {
      return result?.valueCodeableConcept?.coding?.[0]?.code ?? "";
    });

  const paymentMethod = await medplum
    .searchOne("Observation", {
      subject: joinReferenceString("Patient", clientId),
      code: QuiltedHealthCodes.PaymentMethod,
      _sort: "-_lastUpdated",
    })
    .then((result) => {
      return result?.valueCodeableConcept?.coding?.[0]?.display ?? "";
    });

  return {
    coverage: coverage?.[0] ?? undefined,
    medicaidResponseCode,
    paymentMethod: paymentMethod ?? "",
  };
}
